module.exports = __webpack_public_path__ + "img/2-3.4a270ea6.svg";